"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormSubmit = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _concernFormContext = require("../../contexts/concernFormContext");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FormSubmit = (param)=>{
    let { isSubmitting } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { translations } = (0, _useTranslations.useTranslations)();
    const { concernFormData, isFormSent, isServerError } = (0, _concernFormContext.useConcernForm)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.StyledSubmit, {
        "data-testid": getTestId(_constants.FORM_SUBMIT),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledButton, {
                color: "primary",
                disabled: isFormSent || isSubmitting,
                name: "submit",
                size: "medium",
                type: "submit",
                variant: "contained",
                children: concernFormData.sendButton
            }),
            isServerError ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                color: "error.main",
                "data-testid": getTestId(_constants.SUBMIT_ERROR_MESSAGE),
                children: translations.networkError
            }) : null
        ]
    });
};
exports.FormSubmit = FormSubmit;
